import React from "react";
import HeroSlider from "./components/HeroSlider/HeroSlider";
import QuienesSomos from "./components/QuienesSomos/QuienesSomos";
import Proyecto from "./components/Proyecto/Proyecto";
import NuestraHistoria from "./components/NuestraHistoria/NuestraHistoria";
import CasaAbierta from "./components/CasaAbierta/CasaAbierta";
import NuestroParque from "./components/NuestroParque/NuestroParque";
import Noticias from "./components/Noticias/Noticias";
import "./gasometros.css";

function Gasometros() {
  return (
    <main>
      <div className="component-spacing">
        <HeroSlider />
      </div>
      <div className="component-spacing">
        <QuienesSomos />
      </div>
      <div className="component-spacing">
        <Proyecto />
      </div>
      <div className="component-spacing">
        <NuestraHistoria />
      </div>
      <div className="component-spacing">
        <CasaAbierta />
      </div>
      <div className="component-spacing">
        <NuestroParque />
      </div>
      <div>
        <Noticias />
      </div>

    </main>
  );
}

export default Gasometros;
